import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraInput } from '@mono/ui-components';
import { useQuery } from '@tanstack/react-query';
import { useMemo, useState } from 'react';
import { useDebounce } from '../../hooks/useDebounce';
import { opportunityApiConnect } from '../../lib/api/opportunityApi.connect';
const SEARCH_DEBOUNCE_MS = 300;
export function MorgansNoticePicker({ excludedNoticeIds, onSelect, searchTestId, optionTestId, placeholder = 'Search notices…', ariaLabel }) {
    const [query, setQuery] = useState('');
    const debounced = useDebounce(query, SEARCH_DEBOUNCE_MS);
    const enabled = debounced.trim().length > 0;
    const { data, isFetching } = useQuery({
        queryKey: [
            'morgans-notice-search',
            debounced
        ],
        enabled,
        queryFn: ()=>opportunityApiConnect.listOpportunities({
                search: debounced.trim(),
                limit: 8
            })
    });
    const results = useMemo(()=>{
        const rows = data?.opportunities ?? [];
        if (!excludedNoticeIds || excludedNoticeIds.size === 0) return rows;
        return rows.filter((o)=>!excludedNoticeIds.has(o.noticeId));
    }, [
        data?.opportunities,
        excludedNoticeIds
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-1",
        children: [
            /*#__PURE__*/ _jsx(SpecraInput, {
                value: query,
                onChange: (e)=>setQuery(e.target.value),
                placeholder: placeholder,
                "data-testid": searchTestId,
                "aria-label": ariaLabel
            }),
            enabled && /*#__PURE__*/ _jsxs("ul", {
                className: "max-h-48 overflow-auto rounded-md border bg-background",
                children: [
                    results.map((o)=>/*#__PURE__*/ _jsx("li", {
                            children: /*#__PURE__*/ _jsxs("button", {
                                type: "button",
                                className: "flex w-full flex-col items-start gap-0.5 px-3 py-2 text-left text-sm hover:bg-muted",
                                "data-testid": optionTestId,
                                onClick: ()=>{
                                    onSelect({
                                        noticeId: o.noticeId,
                                        title: o.title
                                    });
                                    setQuery('');
                                },
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "font-medium",
                                        children: o.title || o.noticeId
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-xs text-muted-foreground",
                                        children: o.noticeId
                                    })
                                ]
                            })
                        }, o.noticeId)),
                    results.length === 0 && !isFetching && /*#__PURE__*/ _jsx("li", {
                        className: "px-3 py-2 text-sm text-muted-foreground",
                        children: "No matching notices"
                    }),
                    isFetching && results.length === 0 && /*#__PURE__*/ _jsx("li", {
                        className: "px-3 py-2 text-sm text-muted-foreground",
                        children: "Searching…"
                    })
                ]
            })
        ]
    });
}
